import { FilterPipe } from './../../../pipe/filter.pipe';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-ion-common-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnChanges {

  @ViewChild('inputSearch', { read: ElementRef })
  inputSearch: ElementRef<HTMLInputElement>;
  @Input()
  placeholder: string;
  @Input()
  list: any[];
  @Input()
  fieldSearch: string;
  @Input()
  textError: string;
  @Input()
  initValidate = 1;
  @Input()
  maxLength = 40;
  @Input()
  ariaLabel: string;
  ariaLabelInput: string;
  @Output()
  sendTextSearch = new EventEmitter<string>();
  @Input()
  textSearch = '';
  lastText = '';
  @Input()
  errorMsgTextSearch = false;
  @Input()
  totalItem: number;
  statusResult = '';
  hideStatusResult = true;
  @Input()
  filterIncludes: false;

  constructor(
    private platform: Platform,
  ) { }

  ngOnInit() {
    this.totalItem = this.setTotalItem(this.list);
    this.setAriaLabel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.textSearch !== undefined) {
      this.checkTextSearch();
    }
  }

  checkTextSearch($event?: any) {
    const filterPipe = new FilterPipe();
    const textTransform = this.textSearch?.toLowerCase().trim();
    const arrayFilered = filterPipe.transform(this.list, textTransform, this.fieldSearch, this.filterIncludes)
    this.errorMsgTextSearch = (arrayFilered.length === this.list.length)
    && (arrayFilered === this.list) && (this.textSearch?.length > 0) ? true : false;
    this.totalItem = arrayFilered.length;

    this.setAriaLabel();

    if ($event && $event?.which !== 13 && this.textSearch?.length > 0) {
      setTimeout(() => {

        this.hideStatusResult = false;
        this.setStatusResult();
        setTimeout(() => {
          this.hideStatusResult = true;
          this.statusResult = '';
        }, 2000);

      }, 1000);
    }
  }

  resetSearch(e: any) {
    e.preventDefault();
    this.inputSearch.nativeElement.blur();

    if (this.platform.is('ios')) {
      this.inputSearch.nativeElement.setAttribute('disabled', 'disabled');
      setTimeout(() => {
        this.inputSearch.nativeElement.focus();
        this.initSearch();
        this.inputSearch.nativeElement.removeAttribute('disabled');
      }, 10);
    } else {
      setTimeout(() => {
        this.initSearch();
        this.inputSearch.nativeElement.readOnly = true;
        this.inputSearch.nativeElement.focus();
        setTimeout(() => this.inputSearch.nativeElement.readOnly = false, 10);
      }, 100);
    }

  }

  initSearch() {
    this.errorMsgTextSearch = false;
    this.textSearch = '';
    this.sendTextSearch.emit('');
    this.checkTextSearch();
  }

  submitInput(e: any) {
    if (e.which === 13) {
      this.setFocus();
    }
  }

  setFocus() {
    this.inputSearch.nativeElement.blur();
    setTimeout(() => this.inputSearch.nativeElement.focus(), 200);
  }

  setTotalItem(list: any[]) {
    return list && list.length > 0 ? list.length : 0;
  }

  setAriaLabel() {
    if (this.errorMsgTextSearch) {
      this.ariaLabelInput = this.textError;
    } else {
      this.ariaLabelInput = this.totalItem === 1
      ? `${this.ariaLabel} ${this.totalItem} resultado disponível`
      : `${this.ariaLabel} ${this.totalItem} resultados disponíveis`;
    }
  }

  setStatusResult() {
    if (this.errorMsgTextSearch) {
      this.statusResult = `${this.textError}`;
    } else {
      if (this.textSearch !== '' || this.textSearch !== undefined) {
        this.statusResult = this.totalItem === 1
      ? `Sua busca retornou ${this.totalItem} resultado`
      : `Sua busca retornou ${this.totalItem} resultados`;
      }
    }
  }

}
